import React from 'react'

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js'
import { Bar } from 'react-chartjs-2'

import { ContainerChart } from '../ContainerChart/ContainerChart'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

const HorizontalBarChart: React.FC = () => {
  const labels = [
    '0 a 3 meses',
    '3 a 6 meses',
    '6 a 9 meses',
    'Risco nao resolvido'
  ]
  return (
    <ContainerChart>
      <Bar
        options={{
          indexAxis: 'y' as const,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'right' as const
            }
          },
          responsive: true
        }}
        data={{
          datasets: [
            {
              backgroundColor: ['#FFB81C', '#59A83B', '#004C97', '#B6CFE6'],
              barPercentage: 1,
              data: [19000000, 10700000, 10000000, 9000000],
              label: ''
            }
          ],
          labels
        }}
      />
    </ContainerChart>
  )
}

export default HorizontalBarChart
